<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Products List</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row justify-content-md-end">
          <div class="col-md-3 col-sm-6">
            <input-select
              :value="search.status"
              name="status"
              placeholder="Filter By"
              class="m-0"
              :options="statusOptions"
              @input="value => gotoSearch({ status: value })"
            />
          </div>
        </div>
      </div>
    </div>
    <loading-container :loading="loading">
      <div v-if="!list || list.length == 0" class="text-center">
        No Product found!
      </div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped dataTable no-footer">
                  <thead>
                  <tr>
                    <th>Image</th>
                    <th>Product Name</th>
                    <th>Store</th>
                    <th>Date created</th>
                    <th>Price</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="(product, index) in list"
                    :class="index % 2 == 0 ? 'odd' : 'even'"
                    :key="product.id"
                  >
                    <td>
                      <a href="javascript:void(0)">
                        <img :src="product.design.imageUrl.small"
                            :alt="product.title" width="60"
                            :class="$options.filters.backgroundColor(product.variation.colors[0])">
                      </a>
                    </td>
                    <td>{{ product.title}}</td>
                    <td>
                      <router-link 
                        :to="{ name: 'storeDetail', params: { storeId: product.storeId }}"
                        v-if="product.store"
                      >
                        {{ product.store.name }}
                      </router-link>
                    </td>
                    <td><span class="text-muted"><i class="fa fa-clock-o"></i> {{ product.createdAt | dateDisplay }}</span> </td>
                    <td><span class="text-success">{{ product.price | priceDisplay }}</span></td>
                    <td>
                      <product-status :status="product.syncStatus" />
                    </td>
                    <td>
                      <div>
                        <link-button
                          class="btn btn-secondary mr-1"
                          :click="() => openAddToCartModal(product.id)"
                        >
                          <i class="ti-shopping-cart"></i>
                        </link-button>
                        <button 
                          type="button" 
                          class="btn btn-secondary mr-1"
                          @click="openEditProductModal(product.id)"
                        >
                          <i class="ti-pencil" aria-hidden="true"></i>
                        </button>
                        <link-button
                          class="btn btn-secondary"
                          :click="() => openWarning(product.id)"
                        >
                          <i class="ti-trash"></i>
                        </link-button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <modal
          :show="showAddtoCart"
          :close="() => closeAddToCartModal()"
          title="Choose variation">
          <loading-container :loading="loadingModal">
            <div class="card-body">
              <div class="text-danger alert alert-danger" v-if="error && error.message">
                <small>{{error.message}}</small>
              </div>
              <form @submit.prevent="() => {}">
              <div class="row justify-content-md-end">
                <div class="col-md-12">
                  <input-select
                    :value="form.catalogId"
                    label="Choose Catalog"
                    placeholder="Catalog"
                    :options="catalogOptions"
                    @input="value => { setField({ key: 'catalogId', value: value }) }"
                  />
                </div>
                <div class="col-md-12">
                  <input-select
                    :value="form.color"
                    label="Choose Color"
                    placeholder="Color"
                    :options="typeOptions({catalogId: form.catalogId, type: 'colors'})"
                    @input="value => { setField({ key: 'color', value: value }) }"
                  />
                </div>

                <div class="col-md-12">
                  <input-select
                    :value="form.size"
                    label="Choose Size"
                    placeholder="Size"
                    :options="typeOptions({catalogId: form.catalogId, type: 'sizes'})"
                    @input="value => { setField({ key: 'size', value: value }) }"
                  />
                </div>

                <div class="col-md-12">
                  <input-select
                    :value="form.quantity"
                    label="Choose Quantity"
                    placeholder="Quantity"
                    :options="qtyOptions"
                    @input="value => { setField({ key: 'quantity', value: value }) }"
                  />
                </div>
              </div>
              </form>
            </div>
          </loading-container>
          <div slot="footer" v-if="!loadingModal">
            <form-button
              type="primary"
              :loading="form.loading"
              :click="addTocartProduct"
              text="Add to cart"
            />
          </div>
        </modal>
        <upload-modal
          :showUpModal="showProductDetail"
          :closeUpModal="closeProductDetail"
          :loadingData="loadingModal"
          :multipleRow="true"
          titleUpModal="Edit Product Information"
          :setDesignFormField="setProductFormField"
          :designForm="items"
          :form="form"
          :designFormError="this.productFormError"
          :closeDesignForm="this.closeProductDetail"
          :saveDesignForm="this.updateProductDetails"
          :selectTab="this.selectTab"
          :loading="this.uploadLoading"
        >
        </upload-modal>
        <modal
          :show="form.showDeleteConfirm"
          title="Warning"
          :close="() => setField({ key: 'showDeleteConfirm', value: false })"
        >
          <h2 class="swal2-title" id="swal2-title" style="display: flex;">Are you sure to delete?</h2>

            <div slot="footer">
              <div class="flex-group">
                <link-button
                  class="btn btn-danger mr-2"
                  :click="() => deleteProduct(form.id)"
                >
                <span v-if="deleteLoading">
                  <i class="fa fa-spin fa-spinner" />
                </span>
                  <span v-else>
                  Sure
                </span>
                </link-button>

                <button type="button" class="btn btn-secondary flex-item" @click="() => setField({ key: 'showDeleteConfirm', value: false })">
                  Cancel
                </button>
              </div>
            </div>

        </modal>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
          <pagination
            :route-name="routeName"
            :query="search"
            :current="page"
            :total="total"
          />
        </div>
      </div>
    </loading-container>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import InputSelect from "@/components/Form/InputSelect";
  import InputText from "@/components/Form/InputText";
  import Pagination from "@/components/Misc/Pagination";
  import Modal from "@/components/Misc/Modal";
  import LinkButton from "@/components/Misc/LinkButton";
  import FormButton from "@/components/Form/FormButton";
  import Breadcrumb from "@/components/Common/Breadcrumb";
  import UploadModal from "@/components/Common/UploadModal";
  import ColorPicker from "@/components/Form/ColorPicker";
  import ProductStatus from "@/components/Common/ProductStatus";

  export default {
    name: "ProductList",
    components: {
      LoadingContainer,
      InputSelect,
      Pagination,
      Modal,
      LinkButton,
      InputText,
      FormButton,
      Breadcrumb,
      UploadModal,
      ColorPicker,
      ProductStatus
    },
    beforeMount() {
      const query = this.$route.query;
      const page = query.page ? parseInt(query.page) : 1;
      const status = query.status;

      this.getProducts({ page, search: { status } });
    },
    computed: {
      ...mapGetters({
        list: "product/list",
        search: "product/search",
        loading: "product/loading",
        uploadLoading: "product/uploadLoading",
        deleteLoading: "product/deleteLoading",
        loadingModal: "product/loadingModal",
        count: "product/count",
        total: "product/total",
        page: "product/page",
        form: "product/form",
        items: "product/items",
        error: 'product/error',
        mockupOptions: "upload/mockupOptions",
        showProductDetail: "product/showProductDetail",
        showAddtoCart: "product/showAddtoCart",
        productFormError: "product/productFormError",
        mockupName: "upload/mockupName",
      }),
      statusOptions() {
        return [
          { value: "created", text: "Created" },
          { value: "price", text: "Price" },
          { value: "status", text: "Status" },
          { value: "published", text: "Published" }
        ];
      },
      catalogOptions() {
        const catalogs = this.items
          .map(o => {
            return {
              value: o.catalogId,
              text: this.catalogName(o.catalogId, this.mockupOptions)
            };
          });

        return catalogs;
      },
      qtyOptions() {
        let qtys = [];
        for (let i = 1; i <= 100; i++) {
          qtys.push({value: i, text: i});
        }
        return qtys;
      },
      routeName() {
        return this.$router.name;
      },
      currentPage() {
        return this.$store.state.route.meta.title;
      }
    },
    methods: {
      ...mapActions({
        getProduct: "product/getProduct",
        getProducts: "product/getProducts",
        setField: "product/setField",
        openAddToCartModal: "product/openAddToCartModal",
        closeAddToCartModal: "product/closeAddToCartModal",
        addTocartProduct: "product/addTocartProduct",
        setProductFormField: "product/setProductFormField",
        openProductDetail: "product/openProductDetail",
        updateProductDetails: "product/updateProductDetails",
        closeProductDetail: "product/closeProductDetail",
        openEditProductModal: "product/openEditProductModal",
        selectTab: "product/selectTab",
        deleteProduct: "product/deleteProduct",
      }),
      gotoSearch(query) {
        this.$router.push({ name: this.routeName, query });
      },
      typeOptions({catalogId, type}) {
        if (catalogId) {
          const thisCatalog = this.items.find(item => item.catalogId === parseInt(catalogId));
          const options = thisCatalog.variation[type]
            .map(o => {
              return {
                value: o,
                text: o
              };
            });

          return options;
        }
      },
      catalogName(catalogId, mockupOptions) {
        const mockup = mockupOptions.find(o => o.value == catalogId);
        return mockup ? mockup.text : 'Unknown';
      },
      openWarning(id) {
        this.setField({ key: 'showDeleteConfirm', value: true });
        this.setField({ key: 'id', value: id });
      },
    }
  };
</script>
